import { render, staticRenderFns } from "./ObtainingPayment.vue?vue&type=template&id=51a449b2&"
import script from "./ObtainingPayment.vue?vue&type=script&lang=js&"
export * from "./ObtainingPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports